import { usePhoneStore } from 'v2/state/phone'
import type Plivo from 'plivo-browser-sdk'
import { phoneLogger } from '../../logger'
import type { IMediaManager } from '../types'

export class MediaManager implements IMediaManager {
  sdk: Plivo | null = null

  async toggleMute(): Promise<void> {
    const { isMuted, activeCall } = usePhoneStore.getState()
    if (!this.sdk?.client || !activeCall) {
      phoneLogger.warn('Cannot toggle mute - no active call or SDK not initialized')
      return
    }

    phoneLogger.info(`${isMuted ? 'Unmuting' : 'Muting'} call`)
    if (isMuted) await this.sdk.client.unmute()
    else await this.sdk.client.mute()

    usePhoneStore.getState().setMuted(!isMuted)
  }

  async sendDTMF(dtmf: string): Promise<void> {
    if (!this.sdk?.client) {
      phoneLogger.warn('Cannot send DTMF - SDK not initialized')
      return
    }

    await this.sdk.client.sendDtmf(dtmf)
  }
}
